import {dqs, error_handler} from '../../lib/util'
import {get_message as $m} from '../../lib/messages'
import {get_regular_donation} from './get_regular_donation'
import {update_donation} from './update_donation'
import { cancel_donation } from './cancel_donation'
import {notify} from '../../lib/notifications'

const REGULAR_DONATION_LINK = 'https://donate.actionstation.org.nz/?period=monthly'

const increase_buttons = dqs('form#update_donation button.update')
const form = dqs('form#update_donation')
let regular_donation_period = ''

const get_updated_amounts = amount => {
  const transformations = [
    [1, 1], [1.25, 0], [1.5, 0], [0.9, 0], [0.75, 0], [0.5, 0]
  ]

  return transformations.map(
    ([multiple, addition]) => Math.round((amount * multiple) + addition)
  )
}

const select_increase = event => {
  const selected_button = event.target

  for(const button of increase_buttons) {
    button.classList.remove('btn-info')
    button.classList.add('btn-outline-dark')
    button.dataset.selected = false
  }

  selected_button.classList.remove('btn-outline-dark')
  selected_button.classList.add('btn-info')
  selected_button.dataset.selected = true
}

export const upgrade_donation = async () => {
  const {email} = JSON.parse(sessionStorage.user)
  const regular_donation = await get_regular_donation(email)

  if(!regular_donation) {
    window.location.hash = 'dashboard'
    return false
  }

  const {amount, period} = regular_donation
  const increased_amounts = get_updated_amounts(amount).entries()
  const message = $m('REGULAR_DONATION', amount, period.replace('ly', ''))
  dqs('#regular_donation').innerHTML = message

  for(const [i, increased_amount] of increased_amounts) {
    increase_buttons[i].dataset.amount = increased_amount
    increase_buttons[i].innerHTML = `$${increased_amount}`
    increase_buttons[i].addEventListener('click', select_increase)
  }

  form.addEventListener(
    'submit', event => {
      event.preventDefault()
      update_donation(email, regular_donation)
    }
  )

  const cancel_button = dqs('#cancel_btn')
  cancel_button.addEventListener(
    'click', event => {
      event.preventDefault()
      cancel_donation(email, regular_donation)
    }
  )
}
